
const defaultIntervention = {
    name: "",
    parameters: "",
}

export default defaultIntervention;
